type LogoMarkProps = {
  /** Rendered width in px; height keeps the 5:4 ratio. */
  size?: number;
  /** Colour of the loop stroke. */
  stroke?: string;
  /** Colour of the "i" dot. */
  dot?: string;
  strokeWidth?: number;
  className?: string;
  /** Accessible name. Omit for decorative use (next to the wordmark). */
  title?: string;
};

/** The single-stroke path of the i∞ mark, on a 50×40 grid. */
export const LOGO_PATH =
  "M6 13 V24 C6 33 13 37 19 33 C25 29 27 19 34 17 C41 15 46 21 46 27 C46 34 39 37 33 34 C28 31 25 25 20 23";

/** The Infinitude Stack "i∞" mark — an "i" whose stem flows into an infinity loop. */
const LogoMark = ({
  size = 36,
  stroke = "var(--is-text)",
  dot = "var(--is-accent)",
  strokeWidth = 4.2,
  className,
  title,
}: LogoMarkProps) => (
  <svg
    width={size}
    height={(size * 4) / 5}
    viewBox="0 0 50 40"
    className={className}
    role={title ? "img" : undefined}
    aria-label={title}
    aria-hidden={title ? undefined : true}
  >
    <circle cx="6" cy="6" r="4" fill={dot} />
    <path
      d={LOGO_PATH}
      fill="none"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
    />
  </svg>
);

export default LogoMark;
